import { useContext, useState } from "react";
import { DatePickerInputNew } from "../../../Helpers/Input/Input";
import { useSelector } from "react-redux";
import trans, { formatDateForAPI, isRTL } from "../../../../utils";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";
import { DeviceAssignmentStatus, ServiceType, TaskReportStatus } from "../../../../constants";
import { countries } from "../../../../utils/CountryState/countries";
import { state, state as states } from "../../../../utils/CountryState/states";
import { usePois } from "../../../../hooks/usePOIs";
import { cities } from "../../../../utils/CountryState/cities";
import { exportContext } from "../../../../context/ExportDataContext";
import { useTechnicians } from "../../../../hooks/useTechnicians";
import { useUsers } from "../../../../hooks/useUsers";
import { UserOutlined } from "@ant-design/icons";
import { InputNumber } from "antd";

export default function ReportWorkforceInput({
  values,
  setFieldValue,
  reportType,
}) {
  const inf = useSelector((state) => state.users.user);
  const { setStartDateE, setEndDateE } = useContext(exportContext);
  const { options: poisOptions, isFetching: poiLoading } = usePois();
  //   const { data: usersOptions, isLoading: usersLoading } = useGetChildUsersQuery(
  //     { userId: inf?.id },
  //     {
  //       skip: !inf?.id,
  //     }
  //   );
  const { options: usersOptions, isFetching: usersLoading } = useTechnicians();
  const { customerOptions } = useUsers();
  const [stateId, setStateId] = useState();
  // Location state for country/state/city dropdowns
  const [location, setLocation] = useState({
    country: values?.country ? values.country : null,
    state: values?.state ? values.state : null,
    city: values?.city ? values.city : null,
  });

  // 🔹 Dropdown dependencies
  const availableStates =
    states.find(
      (s) =>
        s.countryName === location.country || s.country === location.country
    )?.states || [];

  const sanitizeForSQL = (str) => {
    // Allow only letters, numbers, spaces, and basic punctuation like hyphens
    return str.replace(/[^a-zA-Z0-9\s\-]/g, "");
  };

  const fieldVisibility = {
    serviceType: ["efficiency", "productivity", "requests"], // shown for these
    status: ["productivity", "deviceAssignment"],
    country: ["productivity"],
    state: ["productivity"],
    city: ["productivity"],
    poiId: ["efficiency", "productivity"],
    assigneeIds: ["efficiency", "requests", "deviceAssignment"],
    technicianIds: ["attendance", "dailyAttendance"],
    requesterIds: ["requests"],
    // min_assignments: ["deviceAssignment"],
  };

  const shouldShow = (field) => fieldVisibility[field]?.includes(reportType);

  return (
    <div className="form-section" dir={isRTL ? "rtl" : "ltr"}>
      <div className="row">
        <div className="col-lg-12">
          <DatePickerInputNew
            id="dateRange"
            name="dateRange"
            title={reportType === "productExpiration" ? trans("Submission Date Range") : trans("Date Range")}
            formstyle="form-input"
            onChange={({ startDate, endDate }) => {
              setFieldValue("startDate", formatDateForAPI(startDate));
              setFieldValue("endDate", formatDateForAPI(endDate));
              setStartDateE(formatDateForAPI(startDate));
              setEndDateE(formatDateForAPI(endDate));
            }}
            startDate={values?.startDate || null}
            endDate={values?.endDate || null}
          />
        </div>
          {shouldShow("serviceType") && (
        <div className="col-lg-6">
            <InputSelect
              id="serviceType"
              name="serviceType"
              label={trans("Service Type")}
              placeholder={trans("Select Service Type")}
              options={ServiceType}
              value={values.serviceType}
              formstyle="form-input select-z-index"
              onChange={(value) => setFieldValue("serviceType", value)}
              mode="multiple"
            />
        </div>
          )}
        {/* {shouldShow("min_assignments") && (
          <div className="col-lg-6">
            <label className="form-label">{trans("Min Assignments")}</label>
            <InputNumber
              id="min_assignments"
              name="min_assignments"
              label={trans("Min Assignments")}
              placeholder={trans("Enter min assignments")}
              value={values?.min_assignments || 0}
              onChange={(val) => setFieldValue("min_assignments", val)}
              style={{ width: "100%" }}
            />
          </div>
        )} */}
        {shouldShow("status") && (
            <div className="col-lg-6">
              <InputSelect
                id="status"
                name="status"
                label={trans("status")}
                placeholder={trans("Select status")}
                options={reportType === "deviceAssignment" ? DeviceAssignmentStatus : TaskReportStatus}
                value={values.status}
                onChange={(val) => setFieldValue("status", val)}
                // onBlur={() => setFieldTouched("status", true)}
                // errors={errors.status}
                // touched={touched.status}
                formstyle="form-input select-z-index"
                // disabled={getDisabled("status")}\
                mode="multiple"
              />
            </div>
        )}
            {shouldShow("country") && (
            <div className="col-lg-6">
              <InputSelect
                label={trans("Country")}
                name="country"
                id="country"
                placeholder={trans("Select Country")}
                options={countries.map((i) => ({
                  label: trans(i.name),
                  value: i.name,
                }))}
                value={location.country}
                onChange={(value) => {
                  setLocation({ country: value, state: null, city: null });
                  setFieldValue("country", value);
                }}
                formstyle="form-input"
              />
            </div>
            )}
            {shouldShow("state") && (
            <div className="col-lg-6">
              <InputSelect
                label={trans("State")}
                name="state"
                id="state"
                placeholder={trans("Select State")}
                options={availableStates.map((i) => ({
                  label: trans(i.name),
                  value: i.name,
                }))}
                value={location.state}
                onChange={(value) => {
                  const countryStates =
                    state.find((s) => s.countryName === location.country)
                      ?.states ||
                    state.find((s) => s.country === location.country)?.states;
                  console.log("Country States", countryStates);
                  const selected = countryStates.find((i) => i.name === value);

                  console.log("selected city mo7afza", selected);
                  if (selected) {
                    setStateId(selected.id);
                    setLocation((prev) => ({ ...prev, state: value }));
                  }
                  setFieldValue("state", value);
                }}
                formstyle="form-input"
              />
            </div>
            )}
            {shouldShow("city") && (
            <div className="col-lg-6">
              <InputSelect
                label={trans("City")}
                name="city"
                id="city"
                placeholder={trans("Select City")}
                options={
                  cities?.flatMap((i) => {
                    const matchedState = i.states?.find(
                      (stateItem) => stateItem.id === stateId
                    );
                    return (
                      matchedState?.cities?.map((city) => ({
                        label: trans(city.name),
                        value: sanitizeForSQL(city.name),
                      })) || []
                    );
                  }) || []
                }
                value={location.city}
                onChange={(value) => {
                  setLocation((prev) => ({ ...prev, city: value }));
                  setFieldValue("city", value);
                }}
                formstyle="form-input"
              />
            </div>
            )}
        {shouldShow("poiId") && (
          <div className="col-lg-6">
            <InputSelect
              id="poiId"
              name="poiId"
              label={trans("POI")}
              placeholder={trans("Select POI")}
              options={poisOptions}
              loading={poiLoading}
              value={values.poiId || []} // make sure it's an array
              onChange={(val) => setFieldValue("poiId", val)}
              // onBlur={() => setFieldTouched("poiId", true)}
              // errors={errors.poiId}
              // touched={touched.poiId}
              formstyle="form-input select-z-index"
              // disabled={getDisabled("poiId")}
              mode="multiple"
            />
          </div>
        )}
        {shouldShow("assigneeIds") && (
          <div className="col-lg-6">
            <InputSelect
              id="assigneeId"
              name="assigneeId"
              label={trans("Field Staff")}
              placeholder={trans("Select field staff")}
              options={usersOptions}
              loading={usersLoading}
              value={values?.assigneeIds || []}
              onChange={(val) => setFieldValue("assigneeIds", val)}
              // onBlur={() => setFieldTouched("poiId", true)}
              // errors={errors.poiId}
              // touched={touched.poiId}
              formstyle="form-input select-z-index"
              // disabled={getDisabled("poiId")}
              mode="multiple"
              optionRender={(option) => (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  {option.data.avatar ? (
                    <img
                      src={option.data.avatar}
                      alt={option.label}
                      style={{ width: 24, height: 24, borderRadius: "50%" }}
                    />
                  ) : (
                    <UserOutlined
                      style={{ width: 24, height: 24, borderRadius: "50%" }}
                    />
                  )}
                  <span>{option.label}</span>
                </div>
              )}
            />
          </div>
        )}
        {shouldShow("technicianIds") && (
          <div className="col-lg-12">
            <InputSelect
              id="technicianIds"
              name="technicianIds"
              label={trans("Field Staff")}
              placeholder={trans("Select field staff")}
              options={usersOptions}
              loading={usersLoading}
              value={values?.technicianIds || []}
              onChange={(val) => setFieldValue("technicianIds", val)}
              // onBlur={() => setFieldTouched("poiId", true)}
              // errors={errors.poiId}
              // touched={touched.poiId}
              formstyle="form-input select-z-index"
              // disabled={getDisabled("poiId")}
              mode="multiple"
              optionRender={(option) => (
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  {option.data.avatar ? (
                    <img
                      src={option.data.avatar}
                      alt={option.label}
                      style={{ width: 24, height: 24, borderRadius: "50%" }}
                    />
                  ) : (
                    <UserOutlined
                      style={{ width: 24, height: 24, borderRadius: "50%" }}
                    />
                  )}
                  <span>{option.label}</span>
                </div>
              )}
            />
          </div>
        )}
        {shouldShow("requesterIds") && (
          <div className="col-lg-6">
            <InputSelect
              id="requesterIds"
              name="requesterIds"
              label={trans("Requesters")}
              placeholder={trans("Select requester")}
              options={customerOptions}
              loading={usersLoading}
              value={values?.requesterIds || []}
              onChange={(val) => setFieldValue("requesterIds", val)}
              // onBlur={() => setFieldTouched("poiId", true)}
              // errors={errors.poiId}
              // touched={touched.poiId}
              formstyle="form-input select-z-index"
              // disabled={getDisabled("poiId")}
              mode="multiple"
            />
          </div>
        )}
      </div>
    </div>
  );
}
